module.exports = __webpack_public_path__ + "static/media/Logo.12bede6c.png";